export async function execQuery(queryFunc, variables = {}) {
  const runtimeConfig = useRuntimeConfig()
  const gqlHost = runtimeConfig.public.GQL_HOST
  const domain = runtimeConfig.public.DOMAIN
  const headers = useRequestHeaders()
  const cookie = useCookie('ressources_user_token', {
    maxAge: 3600,
    domain,
  })
  try {
    const userIp =
      headers['x-forwarded-for']?.split(',')[0] || headers['x-real-ip']
    const result = await $fetch(gqlHost, {
      headers: {
        Authorization: cookie.value ?? decodeURI(headers?.authorization),
        'X-User-IP': userIp, // Forward the user's IP
      },
      method: 'POST',
      body: JSON.stringify({
        query: queryFunc(),
        variables: variables,
      }),
    })
    if (result?.errors?.[0]?.message === 'Redirect') {
      throw new Error('Redirect')
    }

    if (result?.errors?.[0]?.message === 'Forbidden') {
      throw new Error('Forbidden')
    }
    if (result && result.errors) {
      throw new Error('Graphql error(s) occured', result.errors)
    }
    return result
  } catch (error) {
    if (error?.message === 'Redirect') {
      throw new Error('Redirect')
    }
    if (error?.message === 'Forbidden') {
      throw new Error('Forbidden')
    }
    throw new Error('Graphql error(s) occured', error)
  }
}
